import { Button } from 'components/Button/Button'
import { translate } from 'i18n/i18n'
import type { TScheduleEditButtonsProps } from './types'

export const ScheduleEditButtons = ({
  isEditMode,
  hasChanges,
  saveInProgress,
  onEditClick,
  onCancelClick,
  onSaveClick,
}: TScheduleEditButtonsProps) => (
  <>
    <Button onClick={isEditMode ? onCancelClick : onEditClick}>
      {isEditMode ? translate.phrases.banyanApp('Cancel Edit') : translate.phrases.banyanApp('Edit Schedule')}
    </Button>
    {isEditMode && (
      <Button onClick={onSaveClick} disabled={saveInProgress || !hasChanges} css={{ marginLeft: '8px' }}>
        {saveInProgress
          ? translate.phrases.banyanApp('Saving...')
          : translate.phrases.banyanApp('Save Schedule')}
      </Button>
    )}
  </>
)
